// extracted by extract-css-chunks-webpack-plugin
module.exports = {"customLink":"iQ2RY","noCursor":"aw0Q7"};